module.exports = __webpack_public_path__ + "static/media/svg-1.50b81502.svg";